import FractionDsnMail from '@/generated/controls/fractionDsn/FractionDsnMail.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: FractionDsnMail
})

